/* eslint-disable */
import Api from '@/repository/index'
import { getToken, removeToken, setToken } from '@/utils/auth'
import { showDefaultErrorMessage } from '@/utils/createMessage'
import router from '@/core/utils/router'
import { getALivableRedirectPatch } from '@/router/helpers'
// import { getConfigByRouteName } from '@/utils/accessConfig'
const state = {
  token: getToken(),
  refreshToken: '',
  userEmailData: '',
  user: {}
}

const mutations = {
  SET_TOKEN: (state, { response, email }) => {
    state.token = `Bearer ${response.accessToken}`
    state.refreshToken = `Bearer ${response.refreshToken}`
    state.userEmailData = email
  },
  SET_EMPTY_TOKEN: (state) => {
    state.token = ''
    state.refreshToken = ''
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  UPDATE_ACTIVE_PARK: (state, parkID) => {
    const getPark = state.user.parks.find(x => x.id === parkID)
    state.user = {
      ...state.user,
      actual_park: getPark
    }
  }
}

const getters = {
  // rdy
  GET_TOKEN: (state) => {
    return state.token
  },
  // rdy
  GET_REFRESH_TOKEN: (state) => {
    return state.token
  },
  // rdy
  jwtTokenData: (state) => {
    const jwtToken = state.token.split(' ')[1]
    const tokenParts = jwtToken.split('.')

    return {
      headers: JSON.parse(atob(tokenParts[0])),
      payload: JSON.parse(atob(tokenParts[1]))
    }
  },
  // rdy
  getActualPark: (state, getters) => {
    // Получать парк из state.user.actual_park не надежно -
    // если два пользователя одновременно работают и один из них изменит парк
    return state.user.parks.find(e => e.id === getters.jwtTokenData.payload.park)
  },
  // rdy
  getUser: (state) => {
    return state?.user
  },
  // rdy
  getUserParks: (state) => {
    return state?.user?.parks
  },
  // rdy
  getUserParkNameById: (state) => {
    return (id) => {
      return state?.user?.parks.find(x => x?.id === id)?.name
    }
  },
  // rdy
  getUserRoles: (state) => {
    return state?.user?.role
  },
  // rdy
  isSetUser: (state) => {
    return Object.keys(state?.user).length !== 0
  },
  // rdy
  isUserFullAdmin: (state) => {
    const gelAllRolesAliases = state?.user?.role?.map(x => x?.alias) ?? []
    return gelAllRolesAliases.includes('admin') | gelAllRolesAliases.includes('park_owner')
  },
  // rdy
  getUserRolesAccsessesCategories: (state) => {
    return state?.user?.accessCategories?.map(x => x.alias)
  },
  // rdy
  getUserRolesAccsesses: (state) => {
    return state?.user?.role?.reduce((acc, value) => {
      const data = value?.accesses?.map(x => x?.alias) ?? []
      acc = [...acc, ...data]
      return acc
    }, [])
  }
}

const actions = {

  async login ({ commit, getters, dispatch }, userData) {
    try {
      const { email, password } = userData
      const response = await Api.auth.login(email, password)
      commit('SET_TOKEN', { response, email })
      setToken(`Bearer ${response?.accessToken}`)
      await dispatch('fetchUser')
      console.log(getALivableRedirectPatch(getters.getUserRolesAccsessesCategories), getters.getUserRolesAccsessesCategories)
      router.push({ name: getALivableRedirectPatch(getters.getUserRolesAccsessesCategories) || 'dashboard' })
      return response
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async switchPark ({ commit, state }, parkID) {
    try {
      const response = await Api.user.switchPark(parkID)
      commit('SET_TOKEN', { response, email: state.userEmailData })
      // commit('UPDATE_ACTIVE_PARK', parkID)
      await setToken(`Bearer ${response?.accessToken}`)
      // const { name, query, params } = router.currentRoute
      // await getConfigByRouteName({ name, query, params })
      window.location.reload(true)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchUser ({ commit }) {
    try {
      const response = await Api.user.getMe()
      console.log(response)
      commit('SET_USER', response)
      return response
    } catch (err) {
      showDefaultErrorMessage()
      removeToken()
      await router.push(('/login'))
      return Promise.reject(err)
    }
  },
  logout ({ commit }) {
    return new Promise(resolve => {
      commit('SET_EMPTY_TOKEN')
      removeToken()
      resolve()
      router.push({ path: '/login' })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
